import React from 'react'

export const FieldDescription = ({ children }) => {
  return <p className='body-small text-brand-gray-dark pl-[2px]'>{children}</p>
}
